
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/_internal/for-sale/[address_id]",
      function () {
        return require("private-next-pages/marketplace/_internal/for-sale/[address_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace/_internal/for-sale/[address_id]"])
      });
    }
  